import React from 'react';
import AboutImage from "./aboutHeader.png";
import overlayImage from "../commonImg/overlay2-50.svg";
function Header() {
    const st5={
        backgroundImage:`url(${AboutImage})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundAttachment:'initial'
    };
    const overlay={
        backgroundImage:`url(${overlayImage})`,
    };
    const headerStyle={
        textShadow:'1px 0 0 #fff, -2px 0 0 #fff, 0 2px 0 #fff, 0 -2px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
    };
    return(
        <header className="hero hero-fluid hero-page txt-color-sasha-darkest" style={st5}>
            <div style={overlay}>
                <div className="container nfloat-down">
                    <h1 className="txt-weight-black" style={headerStyle}>Random things about me,</h1>
                    <p className="txt-size-lead"></p>
                </div>
            </div>
        </header>
    )
}
export default Header;
